import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {UnitGroupModel} from '../../../unit/unit-group/unit-group.model';

@Injectable({
  providedIn: 'root'
})
export class UnitGroupSearchService {

  constructor(
    private http: HttpClient
  ) { }

  public getUnitGroupsAvailableToUnit(unitId: number, unitGroupName: string) {
    const params = new HttpParams()
      .set('fields', 'id,name')
      .set('per-page', '20')
      .set('UnitGroupSearch[available_for_unit_id]', unitId.toString())
      .set('UnitGroupSearch[name]', unitGroupName);

    return this.http.get<UnitGroupModel[]>(
      environment.apiBasepoint + 'unit-group',
      {params: params, observe: 'body'}
    );
  }
}
